export default __webpack_public_path__ + "static/media/left-arrow.c220dd51.png";